module.exports = __webpack_public_path__ + "static/media/IMG-4.a1a86f03.jpg";